import React from 'react'
import {
  Route,
  Routes,
  Navigate,
  unstable_HistoryRouter as HistoryRouter,
} from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material/styles'

// import '@fontsource/roboto/300.css'
// import '@fontsource/roboto/300-italic.css'
// import '@fontsource/roboto/400.css'
// import '@fontsource/roboto/400-italic.css'
// import '@fontsource/roboto/500.css'
// import '@fontsource/roboto/500-italic.css'
// import '@fontsource/roboto/700.css'
// import '@fontsource/roboto/700-italic.css'
// import '@fontsource/roboto/900.css'
// import '@fontsource/roboto/900-italic.css'

import CssBaseline from '@mui/material/CssBaseline'
import StaticTopMenu from './static/StaticTopMenu'
import StaticFooter from './static/StaticFooter'
import StaticFormLayout from './layouts/StaticFormLayout'

import { history } from '../router/navigation'

import StaticWelcome from './static/StaticWelcome'
import StaticPolicy from './static/StaticPolicy'
import SignUp from '../redux/features/user/SignUp'
import ConfirmationInstructions from './devise/ConfirmationInstructions'
import ConfirmSignUp from './devise/ConfirmSignUp'
import SignIn from '../redux/features/user/SignIn'
import OpenIdSignIn from './devise/OpenIdSignIn'
import AccountArchived from './devise/AccountArchived'
import ResetPassword from './devise/ResetPassword'
import ChooseNewPassword from './devise/ChooseNewPassword'
import ResendLogin from './devise/ResendLogin'
import ResendConfirmation from './devise/ResendConfirmation'
import ResendUnlock from './devise/ResendUnlock'
import ConfirmUnlock from './devise/ConfirmUnlock'
import SignInRequired from './devise/SignInRequired'
import ArticleIndex from './articles/ArticleIndex'
import Article from './articles/Article'
import NotFound from './NotFound'

const theme = createTheme()

export default function UnauthenticatedRoutes() {
  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        <CssBaseline />
        <HistoryRouter
          history={history}
          future={{ 
            v7_startTransition: true, 
            v7_relativeSplatPath: true 
          }}
        >
          <Routes>

            {/* Form pages */}
            <Route path='app' element={<StaticFormLayout />}>
              {/* /app and /app/ would otherwise show this layout with nothing in it */}
              <Route index element={<Navigate to="/app/welcome" replace />} />
              <Route path='sign_in' element={<SignIn />} />

              <Route path='sign_up' element={<SignUp />} />            
              <Route path='confirmation_instructions' element={<ConfirmationInstructions />} />
              <Route path='user/confirmation' element={<ConfirmSignUp />} /> 

              <Route path='resend_login' element={<ResendLogin />} />
              <Route path='resend_confirmation' element={<ResendConfirmation />} />
              <Route path='resend_unlock' element={<ResendUnlock />} />
              <Route path='user/unlock' element={<ConfirmUnlock />} />

              <Route path='openid_sign_in' element={<OpenIdSignIn />} />
              <Route path='account_archived' element={<AccountArchived />} />
              <Route path='reset_password' element={<ResetPassword />} />
              <Route path='user/password/edit' element={<ChooseNewPassword />} />
              <Route path='policy' element={<StaticPolicy />} />
            </Route>            

            {/* News: Markdown files in articles/news (ArticlesController) */}
            <Route path='/news' element={<StaticFormLayout />}>
              <Route index element={<ArticleIndex collection='news' title='Stikis News' />} />
              <Route path=':slug' element={<Article collection='news' collectionTitle='News' />} />
            </Route>
            {/* Help: Markdown files in articles/help (ArticlesController) */}
            <Route path='/help' element={<StaticFormLayout />}>
              <Route index element={<ArticleIndex collection='help' title='Stikis Help' showDates={false} />} />
              <Route path=':slug' element={<Article collection='help' collectionTitle='Help pages' showDate={false} />} />
            </Route>

            {/* Pages for signed-in users: ask a signed-out visitor to sign in */}
            <Route path='/app/pages' element={<SignInRequired />} />
            <Route path='/app/pages/:id' element={<SignInRequired />} />
            <Route path='/app/account' element={<SignInRequired />} />
            <Route path='/app/account/edit_email' element={<SignInRequired />} />
            <Route path='/app/account/edit_password' element={<SignInRequired />} />
            <Route path='/app/account/delete' element={<SignInRequired />} />

            {/* The account page used to be at /app/user */}
            <Route path='/app/user'
              element={<Navigate to="/app/account" replace />} />
            <Route path='/app/user/edit_email'
              element={<Navigate to="/app/account/edit_email" replace />} />
            <Route path='/app/user/edit_password'
              element={<Navigate to="/app/account/edit_password" replace />} />

            {/* Welcome page layout */}
            <Route path='/app/welcome' element={<StaticWelcome />} />
            <Route 
              path="/app" 
              element={<Navigate to="/app/welcome" replace />} />
            <Route 
              path='/app/*'
              element={<Navigate to="/app/welcome" replace />} />

            {/* Any other address (ErrorsController) */}
            <Route element={<StaticFormLayout />}>
              <Route path='*' element={<NotFound />} />
            </Route>
          </Routes>
        </HistoryRouter>
      </React.Fragment>
    </ThemeProvider>
  )
}